module.exports = __webpack_public_path__ + "static/img/info-button.670b579.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/info-button.png
// module id = 5+6/
// module chunks = 1